import type { RouteLocationRaw } from 'vue-router'

export const resolveRedirect = (
  redirectParam: unknown,
  fallback: RouteLocationRaw = { name: 'dashboard' },
): RouteLocationRaw => {
  if (typeof redirectParam !== 'string' || redirectParam.length === 0) {
    return fallback
  }

  try {
    return decodeURIComponent(redirectParam)
  } catch {
    return redirectParam
  }
}
